/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Text } from '@mybridge/ui/text';
import { Button } from '@mybridge/ui/button';
import { Input, InputGroup, InputLeftElement } from '@mybridge/ui/input';
import { Select } from '@mybridge/ui/select';
import { BENEFITS, CURRENCY, PAYMENT_TYPE } from '../../../../../lib/data';
import { getAllCompanyPages } from '../../../../../store/actions/companyPages.actions';
import { Checkbox, CheckboxGroup } from '@mybridge/ui/checkbox';
import { HStack, Stack, VStack, Box } from '@mybridge/ui/layout';
import _, { isEmpty } from 'lodash';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
} from '@mybridge/ui/form-control';
import currencySymbolMap from 'currency-symbol-map';
import { getGlobalCurrencies } from 'v4/store/actions/global.data.actions';
import { UpdatePartialJob } from 'v4/store/actions/companyJobs.actions';
import { useForm } from 'react-hook-form';
import { Card, LinkButton, Textarea } from '@mybridge/ui';
import { SkillsTaggedInput } from 'v4/components/skills-tag-input';
import { CreateJobsContext } from 'v4/components/company/Layout/context';
import { useRouter } from 'next/router';
import { get } from 'lodash';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
const BenefitsSection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const router = useRouter();
  const {
    setSelectCompany,
    toast,
    createOrUpdateJob,
    createJobLoading,
    updateJobLoading,
    isEdit,
    setSection,
    jobDetails,
    setJobDetails,
    whyWorkHere,
    setWhyWorkHere,
  } = useContext(CreateJobsContext);
  const [defaultCurrency, setDefaultCurrency] = useState('USD');
  const [curreny, setCurrency] = useState('USD');
  const [count, setCount] = useState(0);
  const direction = useDirection();
  const [skills, setSkills] = useState([]);
  const [skill, setSkill] = useState(null);

  const [showMaxSalary, setShowMaxSalary] = useState(false);

  const [noneBenefits, setNoneBeneifts] = useState(false);
  const currencySymbol = currencySymbolMap(curreny) || curreny;
  const { globalCurrencies } = useSelector((state) => state.globalData);
  useEffect(() => {
    dispatch(getAllCompanyPages());
    dispatch(getGlobalCurrencies());
    if (jobDetails?.currency_choice) {
      setDefaultCurrency(jobDetails.currency_choice);
      setCurrency(jobDetails.currency_choice);
    }
    if (jobDetails && jobDetails.benefits === null) {
      setNoneBeneifts(true);
    }
    if (jobDetails && jobDetails.skills?.length) {
      setSkills(jobDetails.skills);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const benefitsWatch = watch('benefits');
  const salaryMin = watch('compensation_range_min_amt');
  const salaryMax = watch('compensation_range_max_amt');
  const currency = watch('currency_choice');
  const paymentChoice = watch('payment_choice');
  const commissionWatch = watch('plus_comission');
  const whyWorkHereWatch = watch('why_work_here');

  const onClickBack = (e) => {
    e.preventDefault();
    setSection(1);

    // Check the current state of the benefits checkboxes
    const benefitsChecked = watch('benefits'); // This will give you the current state of the benefits checkboxes

  };

  const onClickNext = (form) => {
    // console.log(form);
    // console.log(jobDetails);
    const payload = {
      body: {
        benefits: jobDetails?.benefits ? jobDetails?.benefits?.flat() : [],
        id: jobDetails?.id,
        compensation_range_min_amt: jobDetails?.compensation_range_min_amt
          ? jobDetails?.compensation_range_min_amt
          : null,
        compensation_range_max_amt: jobDetails?.compensation_range_max_amt
          ? jobDetails?.compensation_range_max_amt
          : null,
        payment_choice: jobDetails?.payment_choice,
        currency_choice: jobDetails?.currency_choice
          ? jobDetails?.currency_choice
          : 'USD',
        plus_comission: Boolean(jobDetails?.plus_comission),
        why_work_here: jobDetails?.why_work_here
          ? jobDetails?.why_work_here
          : null,
        skills: _.map(skills, (item) => (_.isObject(item) ? item.name : item)),
      },
      id: jobDetails?.id,
      method: 'PUT',
    };
    createOrUpdateJob(payload);
    // setSection(3);
  };

  const onSaveJob = (isDraft) => {
    const payload = {
      body: {
        benefits: jobDetails?.benefits ? jobDetails?.benefits?.flat() : [],
        id: jobDetails?.id,
        compensation_range_min_amt: jobDetails?.compensation_range_min_amt || null,
        compensation_range_max_amt: jobDetails?.compensation_range_max_amt || null,
        payment_choice: jobDetails?.payment_choice,
        currency_choice: jobDetails?.currency_choice || 'USD',
        plus_comission: Boolean(jobDetails?.plus_comission),
        why_work_here: jobDetails?.why_work_here || null,
        skills: _.map(skills, (item) => (_.isObject(item) ? item.name : item)),
      },
      id: jobDetails?.id,
      method: 'PUT',
    };
    // Dispatch the action and handle the response
    dispatch(UpdatePartialJob(payload)).then((res) => {
      const jobId = get(res, 'payload.id');
      if (jobId) {
        setJobDetails();
        setSection(1);
        toast({
          title:  t('createJob.saveJobSuccess') || 'Job Saved Successfully',
          status: 'success',
          isClosable: true,
          position: 'top',
          duration: 9000,
        });
        
        setTimeout(function () {
          router.push(`/page/private/${jobDetails?.hiring_company}/jobs`);
        }, 5000); // Redirect after 5 seconds
      }
    });
  };

  useEffect(() => {
    setJobDetails({
      ...jobDetails,
      benefits: benefitsWatch,
      compensation_range_min_amt: salaryMin,
      compensation_range_max_amt: salaryMax,
      currency_choice: currency,
      payment_choice: paymentChoice,
      why_work_here: whyWorkHereWatch,
      skills: _.map(skills, (item) => (_.isObject(item) ? item.name : item)),
      plus_comission: commissionWatch,
    });
    if (getValues('benefits') !== '' && benefitsWatch !== '') {
      setNoneBeneifts(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    benefitsWatch,
    salaryMin,
    salaryMax,
    currency,
    paymentChoice,
    whyWorkHereWatch,
    skills,
    commissionWatch,
  ]);
  useEffect(() => {
    if (jobDetails && jobDetails.benefits) {
      setValue('benefits', jobDetails.benefits); // Initialize form value with jobDetails
    }
  }, [jobDetails, setValue]);

  const handleNoneBenefits = (e) => {
    if (e.target.checked) {
      setValue('benefits', '');
      setNoneBeneifts(true);
    }
  };

  // console.log(jobDetails?.why_work_here)

  return (
    <form onSubmit={handleSubmit(onClickNext)}>
      {isEdit ? (
        <>
          <Card variant="thinBorderedCard" p={4} mb={6}>
            <Text
              fontSize="md"
              color="brandGray.800"
              fontWeight="semibold"
            ></Text>
            <FormControl mt={2} isInvalid={errors.benefits}>
              <FormLabel
                mb={0}
                fontSize="sm"
                color="brandGray.30"
                fontWeight="medium"
                htmlFor="benefits"
              >
                {t('jobs.benefits') || "Benefits"}
              </FormLabel>

              <VStack align="stretch">
                {BENEFITS.map((item, index) => (
                  <Box key={index} display="flex" alignItems="center">
                    <Checkbox
                      value={item.label}
                      isChecked={
                        (watch('benefits') || [])?.some?.((b) => {
                          if (!b) return false;
                          const bName = typeof b === 'string' ? b : b?.name || b?.label;
                          return bName?.toLowerCase?.() === item.label?.toLowerCase?.();
                        }) || false
                      }
                      id={item.id}
                      my={0}
                      color="brandGray.700"
                      fontSize="md"
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        const currentBenefits = watch('benefits') || []; // Get current value of benefits
                        if (isChecked) {
                          // Add the item if checked
                          setValue('benefits', [
                            ...currentBenefits,
                            item.label,
                          ]);
                        } else {
                          // Remove the item if unchecked
                          setValue(
                            'benefits',
                            currentBenefits.filter(
                              (benefit) => {
                                const bName = typeof benefit === 'string' ? benefit : benefit?.name || benefit?.label;
                                return bName?.toLowerCase?.() !== item.label?.toLowerCase?.();
                              }
                            )
                          );
                        }
                      }}
                    />
                    {/* Manually display the label beside the checkbox */}
                    <Text ml={2} onClick={(e) => e.preventDefault()}>
                      {item.label}
                    </Text>
                  </Box>
                ))}

                <Box display="flex" alignItems="center">
                  <Checkbox
                    value={noneBenefits}
                    isChecked={noneBenefits}
                    my={0}
                    color="brandGray.700"
                    fontSize="md"
                    onChange={(e) => handleNoneBenefits(e)}
                  />
                  <Text ml={2} onClick={(e) => e.preventDefault()}>
                    {t('createJob.noneOfThese') || "None of these"}
                  </Text>
                </Box>
              </VStack>
              {errors.benefits && (
                <FormErrorMessage color="brandRed.500">
                  {t('createJob.pleaseSelectAtLeastOneBenefit') || "Please select at least one benefit"}
                </FormErrorMessage>
              )}
            </FormControl>

            <Text color="brandGray.30" fontSize="sm" mt={4} mb={2}>
              {t('createJob.compensationRange') || "Compensation Range"}
            </Text>
            <Stack spacing={4} maxW="400px">
              <HStack
                flexDir={['column', 'column', 'row']}
                alignItems="center"
                justifyContent="center"
                gap={3}
              >
                <InputGroup flex="1">
                  <InputLeftElement
                    pointerEvents="none"
                    color="black"
                    background="brandGray.500"
                    fontSize="md"
                    children={currency ? currency : currencySymbol}
                    height="48px"
                    width="36px"
                    borderRadius="5px 0 0 5px"
                    border="1px solid brandGray.300"
                  />
                  <Input
                    height="48px"
                    value={jobDetails?.compensation_range_min_amt}
                    background="white"
                    fontSize="sm"
                    py={0}
                    pl={10}
                    placeholder={t('createJob.minAmount') || "Min Amount"}
                    variant="defaultInput"
                    type="number"
                    {...register('compensation_range_min_amt', {
                      required: false,
                    })}
                  />
                </InputGroup>
                {showMaxSalary || jobDetails?.compensation_range_max_amt ? (
                  <>
                    <Text>{t('myEvents.to') || "to"}</Text>
                    <InputGroup flex="1">
                      <InputLeftElement
                        pointerEvents="none"
                        color="black"
                        fontSize="md"
                        background="brandGray.500"
                        children={currencySymbol}
                        height="48px"
                        width="36px"
                        borderRadius="5px 0 0 5px"
                      />
                      <Input
                        height="48px"
                        background="white"
                        name="compensation_range_max_amt"
                        value={jobDetails?.compensation_range_max_amt}
                        {...register('compensation_range_max_amt', {
                          required: false,
                          // validate: (value) => {
                          //   if (value && value <= salaryMin) {
                          //     return t('createJob.maxAmountShouldNotBeLessThanMinAmount') || 'Max amount should not be less than Min Amount';
                          //   }
                          // },
                          validate: (value) => {
                            if (value && salaryMin !== undefined && salaryMin !== null && salaryMin !== "" && Number(value) <= Number(salaryMin)) {
                              return t('createJob.maxAmountShouldNotBeLessThanMinAmount') || 'Max amount should not be less than Min Amount';
                            }
                          },
                        })}
                        fontSize="sm"
                        py={0}
                        pl={10}
                        placeholder={t('createJob.maxAmount') || "Max Amount"}
                        variant="defaultInput"
                        type="number"
                      />
                    </InputGroup>
                  </>
                ) : (
                  <LinkButton
                    size="sm"
                    fontSize="10px"
                    flex="1"
                    textAlign="center"
                    onClick={() => setShowMaxSalary(true)}
                  >
                    {t('createJob.addMaximumAmount') || "Add Maximum amount"}
                  </LinkButton>
                )}
              </HStack>
              {errors.compensation_range_min_amt && (
                <Text color="brandRed.500" mt="-10px">
                  {t('createJob.minAmountRequired') || "Min amount is required"}
                </Text>
              )}
              {errors.compensation_range_max_amt && (
                <Text color="brandRed.500" mt="-10px">
                  {t('createJob.maxAmountShouldNotBeLessThanMinAmount') || "Max amount should not be less than Min Amount"}
                </Text>
              )}

              <HStack
                flexDir={['column', 'column', 'row']}
                alignItems="flex-start"
                gap={3}
              >
                <FormControl isInvalid={errors.currency_choice}>
                  <Select
                    height="38px"
                    fontSize="sm"
                    background="white"
                    id="currency_choice"
                    {...register('currency_choice', {
                      required: false,
                    })}
                  >
                    {globalCurrencies?.map((val) => (
                      <option
                        selected={
                          val.country_code === defaultCurrency ? true : false
                        }
                        value={val.country_code}
                        key={val.country_code}
                      >
                        {val.name} ({val.country_code})
                      </option>
                    ))}
                  </Select>
                </FormControl>

                {/* <FormControl isInvalid={errors.payment_choice}>
                  <Select
                    height="38px"
                    fontSize="sm"
                    background="white"
                    id={'payment_choice'}
                    {...register('payment_choice', {
                      required: false,
                    })}
                  >
                    {PAYMENT_TYPE.map((val) => (
                      <option value={val.value} key={val.value}>
                        {val.label}
                      </option>
                    ))}
                  </Select>
                </FormControl> */}
              </HStack>
              <Box display="flex" alignItems="center">
                <Checkbox
                  {...register('plus_comission', { required: false })}
                  isChecked={jobDetails?.plus_comission}
                  value={jobDetails?.plus_comission}
                  my={0}
                  fontSize="md"
                  color="brandGray.700"
                />
                <Text ml={2} onClick={(e) => e.preventDefault()}>
                  {t('createJob.plusCommission') || "Plus Commission"}
                </Text>
              </Box>
            </Stack>
          </Card>

          <Card variant="thinBorderedCard" p={4} mb={6}>
            <Box mb={3}>
              <Text color="#868585" className="mb-1">
                {t('profileSkills.skills') || "Skills"}
              </Text>
              <Text color="#868585" fS="13px" margin="0 0 3px 0">
                {t('createJob.targetJobseekers') || "Target the jobseekers you need by keyword below"}
              </Text>
              <SkillsTaggedInput
                {...register('skills', {
                  required: false,
                })}
                onChange={(value) => {
                  // console.log(value);
                  setSkills(value);
                }}
                defaultValue={
                  _.some(skills, 'name') ? _.map(skills, 'name') : skills
                }
                // defaultValue={skills}
              />
            </Box>
          </Card>

          <Card variant="thinBorderedCard" p={4} mb={6}>
            <FormControl
              isInvalid={errors.why_work_here || whyWorkHereWatch?.length > 140}
            >
              <FormLabel
                mb={0}
                fontSize="sm"
                color="brandGray.30"
                fontWeight="medium"
                htmlFor="why_work_here"
              >
                {t('createJob.whyWorkAtThisCompany') || "Why Work at this Company?"}
              </FormLabel>
              <Textarea
                value={
                  jobDetails?.why_work_here
                    ? jobDetails?.why_work_here
                    : 'whyWorkHere'
                }
                bg="white"
                {...register('why_work_here', {
                  required: false,
                  maxLength: 140,
                })}
                placeholder={t('createJob.whyWorkAtThisCompany') || "Why Work at this Company?"}
                size="sm"
                resize="none"
              />
              <FormHelperText color="#868585">
                {t('createJob.salesPitchForCompany') || "Give a one-line sales pitch for working at this company (140 characters max.) Note: editing this field will affect all jobs at this hiring company."}
                <span>({whyWorkHereWatch?.length} / 140)</span>
              </FormHelperText>
              {whyWorkHereWatch?.length && (
                <FormErrorMessage mt={0}>
                  {t('createJob.textExceededLimit') || "Text exceeded the limit"}
                </FormErrorMessage>
              )}
              {/* {errors.why_work_here && (
                <FormErrorMessage mt={0}>
                  Some Error Occured
                </FormErrorMessage>
              )} */}
            </FormControl>
          </Card>
        </>
      ) : (
        <Box>
          <Text
            fontSize="md"
            color="brandGray.800"
            fontWeight="semibold"
          ></Text>
          <FormControl mt={2} isInvalid={errors.benefits}>
            <FormLabel
              mb={0}
              fontSize="sm"
              color="brandGray.30"
              fontWeight="medium"
              htmlFor="benefits"
            >
              {t('jobs.benefits') || "Benefits"}
            </FormLabel>

            <VStack align="stretch">
              {BENEFITS.map((item, index) => (
                <Box key={index} display="flex" alignItems="center">
                  <Checkbox
                    value={item.label}
                    isChecked={
                      (jobDetails?.benefits || [])?.some?.((b) => {
                        if (!b) return false;
                        const bName = typeof b === 'string' ? b : b?.name || b?.label;
                        return bName?.toLowerCase?.() === item.label?.toLowerCase?.();
                      }) || false
                    }
                    id={item.id}
                    my={0}
                    color="brandGray.700"
                    fontSize="md"
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      const currentBenefits = watch('benefits') || []; // Get current value of benefits
                      if (isChecked) {
                        // Add the item if checked
                        setValue('benefits', [...currentBenefits, item.label]);
                      } else {
                        // Remove the item if unchecked
                        setValue(
                          'benefits',
                          currentBenefits.filter(
                            (benefit) => {
                              const bName = typeof benefit === 'string' ? benefit : benefit?.name || benefit?.label;
                              return bName?.toLowerCase?.() !== item.label?.toLowerCase?.();
                            }
                          )
                        );
                      }
                    }}
                  />
                  {/* Manually display the label beside the checkbox */}
                  <Text ml={2} onClick={(e) => e.preventDefault()}>
                    {t(item.translationKey) || item.label}
                  </Text>
                </Box>
              ))}

              <Box display="flex" alignItems="center">
                <Checkbox
                  value={noneBenefits}
                  isChecked={noneBenefits}
                  my={0}
                  color="brandGray.700"
                  fontSize="md"
                  onChange={(e) => handleNoneBenefits(e)}
                />
                <Text ml={2} onClick={(e) => e.preventDefault()}>
                  {t('createJob.noneOfThese') || "None of these"}
                </Text>
              </Box>
            </VStack>
            {errors.benefits && (
              <FormErrorMessage color="brandRed.500">
                {t('createJob.pleaseSelectAtLeastOneBenefit') || "Please select at least one benefit"}
              </FormErrorMessage>
            )}
          </FormControl>

          <Text color="brandGray.30" fontSize="sm" mt={4} mb={2}>
            {t('createJob.compensationRange') || "Compensation Range"}
          </Text>
          <Stack spacing={4}>
            <HStack
              flexDir={['column', 'column', 'row']}
              alignItems="center"
              justifyContent="center"
              gap={3}
            >
              <InputGroup flex="1">
                <InputLeftElement
                  pointerEvents="none"
                  color="black"
                  background="brandGray.500"
                  fontSize="md"
                  children={currencySymbol}
                  height="48px"
                  width="36px"
                  borderRadius="5px 0 0 5px"
                  border="1px solid brandGray.300"
                />
                <Input
                  height="48px"
                  value={jobDetails?.compensation_range_min_amt}
                  background="white"
                  fontSize="sm"
                  py={0}
                  pl={10}
                  placeholder={t('createJob.minAmount') || "Min Amount"}
                  variant="defaultInput"
                  type="number"
                  {...register('compensation_range_min_amt', {
                    required: false,
                  })}
                />
              </InputGroup>
              {showMaxSalary || jobDetails?.compensation_range_max_amt ? (
                <>
                  <Text>{t('myEvents.to') || "to"}</Text>
                  <InputGroup flex="1">
                    <InputLeftElement
                      pointerEvents="none"
                      color="black"
                      fontSize="md"
                      background="brandGray.500"
                      children={currencySymbol}
                      height="48px"
                      width="36px"
                      borderRadius="5px 0 0 5px"
                    />
                    <Input
                      height="48px"
                      background="white"
                      name="compensation_range_max_amt"
                      value={jobDetails?.compensation_range_max_amt}
                      {...register('compensation_range_max_amt', {
                        required: false,
                        // validate: (value) => {
                        //   if (value && value <= salaryMin) {
                        //     return t('createJob.maxAmountShouldNotBeLessThanMinAmount') || 'Max amount should not be less than Min Amount';
                        //   }
                        // },
                        validate: (value) => {
                          if (value && salaryMin !== undefined && salaryMin !== null && salaryMin !== "" && Number(value) <= Number(salaryMin)) {
                            return t('createJob.maxAmountShouldNotBeLessThanMinAmount') || 'Max amount should not be less than Min Amount';
                          }
                        },
                      })}
                      fontSize="sm"
                      py={0}
                      pl={10}
                      placeholder={t('createJob.maxAmount') || "Max Amount"}
                      variant="defaultInput"
                      type="number"
                    />
                  </InputGroup>
                </>
              ) : (
                <LinkButton
                  size="sm"
                  fontSize="10px"
                  flex="1"
                  textAlign="center"
                  onClick={() => setShowMaxSalary(true)}
                >
                  {t('createJob.addMaximumAmount') || "Add Maximum amount"}
                </LinkButton>
              )}
            </HStack>
            {errors.compensation_range_min_amt && (
              <Text color="brandRed.500" mt="-10px">
                {t('createJob.minAmountRequired') || "Min amount is required"}
              </Text>
            )}
            {errors.compensation_range_max_amt && (
              <Text color="brandRed.500" mt="-10px">
                {t('createJob.maxAmountShouldNotBeLessThanMinAmount') || "Max amount should not be less than Min Amount"}
              </Text>
            )}
            <HStack
              flexDir={['column', 'column', 'row']}
              alignItems="flex-start"
              gap={3}
            >
              <FormControl isInvalid={errors.company_type}>
                <Select
                  height="38px"
                  fontSize="sm"
                  background="white"
                  id="currency_choice"
                  placeholder="Select currency"
                  {...register('currency_choice', {
                    required: false,
                  })}
                  // sx={direction === 'rtl' ? {
                  //   '&': {
                  //     textAlign: 'left',
                  //   }
                  // } : {}}
                >
                  {globalCurrencies?.map((val) => (
                    <option
                      selected={
                        val.country_code === defaultCurrency ? true : false
                      }
                      value={val.country_code}
                      key={val.name}
                    >
                      {val.name} ({val.country_code})
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl isInvalid={errors.payment_choice}>
                <Select
                  height="38px"
                  fontSize="sm"
                  background="white"
                  id={'payment_choice'}
                  {...register('payment_choice', {
                    required: false,
                  })}
                  // sx={direction === 'rtl' ? {
                  //   '&': {
                  //     textAlign: 'left',
                  //   }
                  // } : {}}
                >
                  {PAYMENT_TYPE.map((val) => (
                    <option value={val.value} key={val.value}>
                      {t(val.translationKey) || val.label}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </HStack>
            <Box display="flex" alignItems="center">
              <Checkbox
                {...register('plus_comission', { required: false })}
                isChecked={Boolean(jobDetails?.plus_comission)}
                value={jobDetails?.plus_comission}
                my={0}
                fontSize="md"
                color="brandGray.700"
              />
              <Text ml={2} onClick={(e) => e.preventDefault()}>
                {t('createJob.plusCommission') || "Plus Commission"}
              </Text>
            </Box>
            <hr />
            <Box mb={3}>
              <Text color="#868585" className="mb-1">
                {t('profileSkills.skills') || "Skills"}
              </Text>
              <Text color="#868585" fS="13px" margin="0 0 3px 0">
                {t('createJob.targetJobseekers') || "Target the jobseekers you need by keyword below"}
              </Text>
              <SkillsTaggedInput
                {...register('skills', {
                  required: false,
                })}
                onChange={(value) => {
                  // console.log(value);
                  setSkills(value);
                }}
                defaultValue={
                  _.some(skills, 'name') ? _.map(skills, 'name') : skills
                }
                // defaultValue={skills}
              />
            </Box>
            <hr />

            <FormControl
              isInvalid={errors.why_work_here || whyWorkHereWatch?.length > 140}
            >
              <FormLabel
                mb={0}
                fontSize="sm"
                color="brandGray.30"
                fontWeight="medium"
                htmlFor="why_work_here"
              >
                {t('createJob.whyWorkAtThisCompany') || "Why Work at this Company?"}
              </FormLabel>
              <Textarea
                defaultValue={
                  jobDetails?.why_work_here
                    ? jobDetails?.why_work_here
                    : whyWorkHere
                }
                bg="white"
                {...register('why_work_here', {
                  required: false,
                  maxLength: 140,
                })}
                placeholder={t('createJob.whyWorkAtThisCompany') || "Why Work at this Company?"}
                size="sm"
              />
              <FormHelperText color="#868585">
                {t('createJob.salesPitchForCompany') || "Give a one-line sales pitch for working at this company (140 characters max.) Note: editing this field will affect all jobs at this hiring company."}
                <span>({whyWorkHereWatch?.length} / 140)</span>
              </FormHelperText>

              {whyWorkHereWatch?.length > 140 && ( // Check character count directly
                <FormErrorMessage mt={0}>
                  {t('createJob.textExceededLimit') || "Text exceeded the limit"}
                </FormErrorMessage>
              )}
              {/* {errors.why_work_here && (
                <FormErrorMessage mt={0}>
                  Some Error Occured
                </FormErrorMessage>
              )} */}
            </FormControl>

            {!isEdit && (
              <>
                <HStack
                  flexDir={isMobile ? "row" : ['column', 'column', 'row']}
                  alignItems="flex-start"
                  mt={3}
                >
                  <Button
                    height="48px"
                    variant="secondary"
                    width="50%"
                    onClick={onClickBack}
                    borderRadius="full"
                    type="button"
                  >
                    {t('buttons.back') || "Back"}
                  </Button>
                  <Button
                    height="48px"
                    variant="primary"
                    width="50%"
                    type="submit"
                    borderRadius="full"
                    isLoading={createJobLoading || updateJobLoading}
                    // onClick={onClickNext}
                  >
                    {t('buttons.next') || "Next"}
                  </Button>
                </HStack>
                <Text fontSize="12px">
                  {t('createJob.needToFinishLater') || "Need to finish up later?"}{' '}
                  <LinkButton onClick={() => onSaveJob()}>
                    {t('createJob.saveAsDraft') || "Save as draft"}
                  </LinkButton>
                </Text>
              </>
            )}
          </Stack>
        </Box>
      )}
    </form>
  );
};

export default BenefitsSection;
